<p class="mb-4">
  Uno o più prodotti hanno più di una riga nella commessa: scegli quale usare per ciascun prodotto
  oppure lascialo fuori commessa.
</p>
<div
  *ngFor="let row of rows"
  class="field grid align-items-center">
  <label class="col-12 md:col-4">{{ row.product_name }}</label>
  <div class="col-12 md:col-8">
    <p-dropdown
      [options]="row.options"
      [(ngModel)]="row.selected"
      optionLabel="label"
      optionValue="id"
      placeholder="Scegli..."
      styleClass="w-full"
      appendTo="body"></p-dropdown>
  </div>
</div>
<div class="modal-footer">
  <div class="flex justify-content-between">
    <p-button
      (onClick)="close()"
      label="Annulla"
      [text]="true"
      styleClass="butt red"
      [rounded]="true"></p-button>
    <p-button
      label="Conferma"
      [disabled]="!canConfirm"
      (onClick)="confirm()"
      styleClass="butt"
      [rounded]="true"></p-button>
  </div>
</div>
